import React, {Component} from 'react';
import FunduLogo from 'components/general/svg/FunduLogo';
import './PoweredBy.scss';
import {connect} from "react-redux";

class PoweredBy extends Component {
  render () {
    const {app} = this.props;
    const logoUrl = app?.config?.main?.logoUrl;
    return (
      <div>
        <a target='_blank' rel='noopener noreferrer' href="/">
          {logoUrl ? <img src={logoUrl} className={'custom'} alt={''}/> : <FunduLogo/>}
        </a>
      </div>
    );
  }
}
export default connect(state => ({app: state.app}))(PoweredBy);
